<template>
  <div class="mains">
      <p class="titles">
          <img :src="succeed" />
          <span>支付成功</span>
      </p>
      <p class="moneys">¥<span>{{money}}</span></p>
      <p class="tipss">已向酒店提交预订，待酒店确认后将向您发送短信 通知，您可通过订单详情查看订单状态。</p>
      <van-button type="default" @click="skip()">查看订单</van-button>
  </div>
</template>

<script>
import {getOrderDetail} from "../api";
export default {
    data(){
        return{
            succeed:require("@/assets/hotel/img/home/paysuccess.png"),
            ordersn:'',
            money:0,
        }
    },
    mounted(){
        //'412101081628392911'
        this.ordersn=this.$route.query.ordersn
        getOrderDetail({order_sn:this.ordersn}).then((res)=>{
            this.money=res.pay_money.toFixed(2);
        })
    },
    methods:{
        skip(){//查看订单详情
            this.$router.push({
                path: "/hotel/statusDetail",
                query: {
                order_sn: this.ordersn,
                },
            })
        }
    }
}
</script>

<style lang="less">
html{
        font-size: calc(var(--sizeScale2)*10px);
    }
.mains{
    padding: 3.0rem 1.5rem 0 1.5rem;
    box-sizing: border-box;
    .titles{
        padding-top: 4.4rem;
        text-align: center;
        font-size: 2.0rem;
        // font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #181818;
        img{
            width: 2.0rem;
            height: 2.0rem;
            position: relative;
            top:0.2rem;
            margin-right: 0.4rem;
        }
    }
    .moneys{
        text-align: center;
        font-size: 1.4rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: #181818;
        span{
            font-size:2.6rem;
        }
    }
    .tipss{
        font-size: 1.5rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: #999999;
    }
    p+p{
        margin-top: 2.0rem;
    }
    .van-button{
        margin-top: 10.0rem;
        width: 100%;
        background: linear-gradient(135deg, #0FBF6D 0%, #108B30 100%);
        border-radius: 2.3rem;
        font-size: 1.8rem;
        // font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
    }
}
</style>